var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSalesForceShow())?_c('v-btn',{attrs:{"depressed":"","type":"button"},on:{"click":function($event){return _vm.moveSalesForce()}}},[_vm._v("\n    "+_vm._s(_vm.$t('view.sales_force.reflect.button_caption.move_sales_force'))+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64132197","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales_force/MoveSalesForceButton.vue
// module id = j4zI
// module chunks = 1